import { api } from '../api/client.js';

// Token lives in localStorage so the session survives page reloads.
const TOKEN_KEY = 'drill.jwt';
export const AUTH_EVENT = 'drill-auth-changed';

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* storage may be unavailable (private mode) — login still works in memory */
  }
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* noop */
  }
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export async function login(username, password, acceptConsent = false) {
  const { data } = await api.post('/auth/login', {
    username,
    password,
    ...(acceptConsent ? { acceptConsent: true } : {}),
  });
  setToken(data.data.token);
  return data.data.user;
}

export async function fetchMe() {
  const { data } = await api.get('/auth/me');
  return data.data.user;
}

export function logout() {
  clearToken();
}
